import { type JSX, For, createSignal } from 'solid-js';
import { IssueCardSkeleton } from '../IssueCard/IssueCardSkeleton';
import { translate } from '@fulcrum/lib';

const Z_INDEX_INTERACTION = 50;

export function LoadingSkeleton(): JSX.Element {
  const [selectedFilter] = createSignal(translate('TC.Topic.ActiveTopics3D'));

  // Actual filter dropdown but disabled for loading state
  const filterDropdownDisabled = (
    <div class="dropdown-pane-container fixed-header-filter-size viewerPanel-dropdown opacity-50">
      <div
        class="name dropdownpane-link text-ellipsis viewerPanel-link"
        style={{ cursor: 'not-allowed' }}
      >
        <span class="text-ellipsis">{selectedFilter()}</span>
        <i class="icon-font tc-icon-arrow-drop-down" />
      </div>
    </div>
  );

  // Actual action buttons but disabled for loading state
  const actionButtonsDisabled = [
    // Add button - disabled
    <div>
      {/* @ts-expect-error -- tc-icon-button is a custom web component not recognized by TypeScript */}
      <tc-icon-button
        icon="tc-icon-content-add"
        size="icon-medium"
        color="tertiary"
        class="dropdownpane-link opacity-50"
        data-cy="icon-button"
        disabled={true}
      />
    </div>,

    // Sort dropdown - disabled
    <div class="dropdown-pane-container connect-dropdown-menu m-width-0 opacity-50">
      <div>
        {/* @ts-expect-error -- tc-dropdown-menu is a custom web component not recognized by TypeScript */}
        <tc-dropdown-menu
          type="icon"
          anchor-icon="icon-font tc-icon-sort"
          anchor-class-name="icon-medium tertiary icon-circle"
          position="right"
          disabled={true}
        />
      </div>
    </div>,

    // Search button - disabled
    <div>
      {/* @ts-expect-error -- tc-icon-button is a custom web component not recognized by TypeScript */}
      <tc-icon-button
        icon="tc-icon-search"
        size="icon-medium"
        color="tertiary"
        class="d-none opacity-50"
        disabled={true}
      />
    </div>,

    // More menu dropdown - disabled
    <div class="dropdown-pane-container connect-dropdown-menu m-width-0 opacity-50">
      <div>
        {/* @ts-expect-error -- tc-dropdown-menu is a custom web component not recognized by TypeScript */}
        <tc-dropdown-menu
          type="icon"
          anchor-icon="icon-font tc-icon-more-vert"
          anchor-class-name="icon-medium tertiary icon-circle"
          drop-down-options={[
            translate('TC.Common.Refresh'),
            translate('TC.Common.Search'),
          ]}
          position="right"
          disabled={true}
        />
      </div>
    </div>,
  ];

  // Content area skeleton
  const contentSkeleton = (
    <div class="w-full h-full font-sans flex flex-col">
      <div class="flex-1 overflow-y-auto overflow-x-hidden">
        <div class="space-y-2">
          <For each={Array.from({ length: 8 }, (_, i) => i)}>
            {(_, index) => {
              return (
                <div
                  class="relative h-[169px]"
                  style={{
                    ['z-index']: Math.max(1, Z_INDEX_INTERACTION - index()),
                  }}
                >
                  <IssueCardSkeleton />
                </div>
              );
            }}
          </For>
        </div>
      </div>
    </div>
  );

  return (
    <div class="w-full h-full relative overflow-hidden bg-white">
      <div class="position-absolute top-0 left-0 right-0 bottom-0">
        <div class="trimble-tabs-content-pane">
          {/* @ts-expect-error -- tc-panel-layout is a custom web component not recognized by TypeScript */}
          <tc-panel-layout
            panel-title={translate('TC.Common.Topics')}
            title-data-cy="topics-title"
            title-section-right={filterDropdownDisabled}
            right-actions={actionButtonsDisabled}
            content={contentSkeleton}
            header-class-name={
              'px-3 py-1 flex flex-nowrap shrink-0 items-center border-b border-gray-2 relative z-[100]'
            }
          />
        </div>
      </div>
    </div>
  );
}
